import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { Link } from "react-router-dom";

interface WebhookEventPayloadProps {
    payload: Record<string, unknown>;
}

export const WebhookEventPayload: React.FC<WebhookEventPayloadProps> = ({ payload }) => {
    return (
        <div className="bg-gray-50 p-2 rounded text-xs overflow-x-auto max-w-md whitespace-pre font-mono">
            {JSON.stringify(payload, null, 2)
                .split("\n")
                .map((line, idx) => {
                    if (
                        typeof payload.eventType === "string" &&
                        payload.eventType.startsWith("client.")
                    ) {
                        const entityIdMatch = line.match(/"entityId":\s*"([^"]+)"/);
                        if (entityIdMatch) {
                            const entityId = entityIdMatch[1];
                            const beforeLink = line.substring(
                                0,
                                entityIdMatch.index! + '"entityId": "'.length,
                            );
                            const afterLink = line.substring(
                                entityIdMatch.index! + entityIdMatch[0].length - 1,
                            );
                            return (
                                <div key={idx}>
                                    {beforeLink}
                                    <Link
                                        to={`/clients/show/${entityId}`}
                                        className={defaultLinkStyle}>
                                        {entityId}
                                    </Link>
                                    {afterLink}
                                </div>
                            );
                        }
                        return <div key={idx}>{line}</div>;
                    } else {
                        return <div key={idx}>{line}</div>;
                    }
                })}
        </div>
    );
};
